enum PowerType {
  Mana = 0,
  Rage = 1,
  Focus = 2,
  Energy = 3,
  ComboPoints = 14,
  Happiness
}

export default PowerType
